
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getAnalytics } from 'firebase/analytics';

// Import the Firebase configuration
import firebaseConfig from '../firebase-applet-config.json';

const finalConfig = {
  ...firebaseConfig,
  databaseURL: `https://${firebaseConfig.projectId}-default-rtdb.firebaseio.com`
};

const app = getApps().length > 0 ? getApp() : initializeApp(finalConfig);
export const auth = getAuth(app);
export const db = getDatabase(app); // RTDB is now 'db'

export const initializeFirebase = async () => {
  console.log("Initializing Firebase with project:", firebaseConfig.projectId, "and DB:", finalConfig.databaseURL);
  
  let analytics;
  if (typeof window !== 'undefined') {
    try {
      analytics = getAnalytics(app);
    } catch (e) {
      console.warn("Analytics initialization failed:", e);
    }
  }

  return { auth, db, analytics };
};

export const getFirebaseAuth = () => auth;
export const getDb = () => db;
export const getAnalyticsInstance = () => getAnalytics(app);
